import { observer } from 'mobx-react-lite';
import {
  CheckboxField,
  FieldGroup,
  TextField,
  Widget,
  WidgetProps,
} from '../../../../../components';
import Product from '../../../store/Product';

export default observer(function HiseWidget({
  product,
  ...rest
}: { product: Product } & WidgetProps) {
  return (
    <Widget surface="gray" title="Pulse Client version" {...rest}>
      <CheckboxField
        helperText="It won't be possible to install the product on Pulse Client versions lower than the specified one"
        label="Set minimal Pulse Client version"
        name="enabled"
        onChange={product.extendedFeatures.minPulseClientVersion.handleChange}
        sx={{ mt: 0 }}
        value={product.extendedFeatures.minPulseClientVersion.enabled}
      />

      {product.extendedFeatures.minPulseClientVersion.enabled && (
        <FieldGroup>
          <TextField
            helperText="For example: 40.4.20"
            label="Minimal Pulse Client version"
            name="minPulseClientVersion"
            onChange={
              product.extendedFeatures.minPulseClientVersion.handleChange
            }
            sx={{ width: 240 }}
            value={
              product.extendedFeatures.minPulseClientVersion
                .minPulseClientVersion
            }
          />
        </FieldGroup>
      )}
    </Widget>
  );
});
